import { Pipe, PipeTransform } from '@angular/core';

import { ProductStatus } from '../../shared/models/product.model';

@Pipe({
    name: 'isProductDeprecated',
    standalone: false
})
export class IsProductDeprecatedPipe implements PipeTransform {

  transform(productStatus: ProductStatus): boolean {
    return productStatus === ProductStatus.DEPRECATED || productStatus === ProductStatus.INACTIVE;
  }
}
